module.exports = __webpack_public_path__ + "static/img/protect.d66273a1.jpg";